import React, { useEffect, useState } from 'react'
import GameCard from '../GameCard'
import mini_tab_img from '../../assets/images/mini_tab_img.png'
const MiniTabCardsSection = () => {
    const [miniData, setMiniData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCasinoData = async () => {
            try {
                const response = await fetch('https://api.1000siljang.xyz/api/games/slot');
                if (!response.ok) {
                    throw new Error('Failed to fetch mini game data');
                }
                const data = await response.json();
                setMiniData(data.lists);
            } catch (err) {
                console.error(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCasinoData();
    }, []);

    // if (loading) return <p className="text-center">Loading mini...</p>;
    // if (error) return <p className="text-center text-red-500">Error: {error}</p>;
    return (
        <>
            {miniData.map((item, index) => (
                <GameCard
                    key={index}
                    game={item}
                />
            ))}
        </>
    )
}

export default MiniTabCardsSection